import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, map, catchError } from 'rxjs';
import Endpoints from '@utils/endpoints';
import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  private emptyUser: User = { firstName: undefined, lastName: undefined, userName: undefined };
  private readonly _user$: BehaviorSubject<User> = new BehaviorSubject<User>(this.emptyUser);

  constructor(private http: HttpClient) { }

  login() {
    window.location.href = Endpoints.LoginUri();
  }

  logout() {
    window.location.href = Endpoints.LogoutUri();
  }

  get user$(): Observable<User> {
    return this.http.get<User>(`${Endpoints.UserInformation()}`);
  }

  get isUserAuthenticated$(): Observable<any> {
    return this.http.get(`${Endpoints.IsAuthenticated()}`).pipe(
      map((data) => {
        return true;
      }));
  }
}
